export default {
      id: "linkedin-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }